var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card-header',{staticClass:"md-card-header-icon md-card-header-blue"},[_c('div',{staticClass:"card-icon"},[_c('md-icon',[_vm._v(_vm._s(_vm.icon))])],1),_c('h4',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }